import Link from 'next/link';
import Text from '@deprecated-ui/common/Text';
import Modal from '@deprecated-ui/common/Modal';
import color from '@deprecated-ui/_style/color';
import { ICompanies } from 'features/earnings/types';
import { TableEarningWrapper, TableEarning } from 'features/earnings/styled';

interface IEarnings extends ICompanies {
  symbol: string;
}

interface IModalEarning {
  visible: boolean;
  onCancel: () => void;
  earning: IEarnings;
  customRenderNumber: ({
    text,
    name,
    isNeedBackgroundColor,
  }: {
    text: string;
    name: string;
    isNeedBackgroundColor: boolean;
  }) => any;
  EARNINGS_TYPE: any;
}

const ModalEarning = ({
  visible,
  onCancel,
  earning,
  customRenderNumber,
  EARNINGS_TYPE,
}: IModalEarning) => {
  const renderValue = (text: string, name: string) => {
    const value = customRenderNumber({
      text,
      name,
      isNeedBackgroundColor: true,
    });
    let style = {};
    let valueText = '';
    if (typeof value === 'string') {
      valueText = value;
    } else {
      valueText = value.children;
      style = value.props.style;
    }

    return <td style={style}>{valueText}</td>;
  };

  return (
    <Modal
      centered
      // @ts-expect-error
      noBorder
      visible={visible}
      onCancel={onCancel}
      closeIcon={
        <div style={{ position: 'absolute', top: -8, right: 15 }}>X</div>
      }
      title={
        <Text
          size="16px"
          family="bold"
          padding="10px 15px"
          style={{ borderBottom: `solid 1px ${color.gainsboro}` }}
        >
          Quarterly EPS Recap
        </Text>
      }
    >
      <TableEarningWrapper>
        <TableEarning>
          <tr style={{ borderBottom: `solid 1px ${color.gainsboro}` }}>
            <td />
            <td>
              <Text family="bold">Symbol</Text>
            </td>
            <td>
              <Link href={`/symbol/${earning.symbol}`}>
                <Text
                  family="bold"
                  color={color.primary}
                  style={{ cursor: 'pointer' }}
                >
                  {earning.symbol}
                </Text>
              </Link>
            </td>
          </tr>
          <tr>
            <td>
              <Text family="bold">Consensus</Text>
            </td>
            <td>
              <Text family="bold">Actual</Text>
            </td>
            <td>
              {customRenderNumber({
                text: earning.consensus.actual,
                isNeedBackgroundColor: false,
                name: EARNINGS_TYPE.CONSENSUS.ACTUAL,
              })}
            </td>
          </tr>
          <tr>
            <td />
            <td>
              <Text family="bold">Estimate</Text>
            </td>
            <td>
              {customRenderNumber({
                text: earning.consensus.estimate,
                isNeedBackgroundColor: false,
                name: EARNINGS_TYPE.CONSENSUS.ESTIMATE,
              })}
            </td>
          </tr>
          <tr style={{ borderBottom: `solid 1px ${color.gainsboro}` }}>
            <td />
            <td>
              <Text family="bold">Surprise</Text>
            </td>
            {renderValue(
              earning.consensus.surprise,
              EARNINGS_TYPE.CONSENSUS.SURPRISE,
            )}
          </tr>
          <tr>
            <td>
              <Text family="bold">Previous Year</Text>
            </td>
            <td>
              <Text family="bold">Actual</Text>
            </td>
            <td>
              {customRenderNumber({
                text: earning.prevyear.actual,
                isNeedBackgroundColor: false,
                name: EARNINGS_TYPE.PREVIOUS_YEAR.ACTUAL,
              })}
            </td>
          </tr>
          <tr>
            <td />
            <td>
              <Text family="bold">Previous</Text>
            </td>
            <td>
              {customRenderNumber({
                text: earning.prevyear.previous,
                isNeedBackgroundColor: false,
                name: EARNINGS_TYPE.PREVIOUS_YEAR.PREVIOUS,
              })}
            </td>
          </tr>
          <tr>
            <td />
            <td>
              <Text family="bold">Change</Text>
            </td>
            {renderValue(
              earning.prevyear.change,
              EARNINGS_TYPE.PREVIOUS_YEAR.CHANGE,
            )}
          </tr>
        </TableEarning>
      </TableEarningWrapper>
    </Modal>
  );
};

export default ModalEarning;
